import { Component, computed, input } from '@angular/core';
import { IsActiveMatchOptions, RouterLink, RouterLinkActive } from '@angular/router';
import { IconComponent, IconType } from '@shared/components';

@Component({
    selector: 'app-menu-item',
    templateUrl: './menu-item.component.html',
    styleUrls: ['./menu-item.component.css'],
    imports: [RouterLink, RouterLinkActive, IconComponent],
})
export class MenuItemComponent {
    label = input.required<string>();
    icon = input<IconType>();
    link = input.required<string>();
    testId = input<string>();
    exact = input(false);

    // The router's default subset match, with only `paths` switched; matrix params (`;page=`) stay ignored.
    readonly activeOptions = computed<IsActiveMatchOptions>(() => ({
        paths: this.exact() ? 'exact' : 'subset',
        matrixParams: 'ignored',
        queryParams: 'subset',
        fragment: 'ignored',
    }));
}
